import { AND, NOT, VAR } from 'shared/api/query/constants';
import { combine } from 'shared/api/query/filter';

export const injectExclusionFilter = (queries, excludedUids, targetModel) => {
  if (excludedUids.length === 0) {
    return queries;
  }

  const shouldInjectFilter = (query) => {
    if (query.alias === undefined || query.alias === VAR) return false;
    return query.model === targetModel;
  };

  const processBlock = (query) => {
    if (!shouldInjectFilter(query)) {
      return query;
    }

    query.filter = combine(AND, [query.filter, {
      op: NOT,
      child: [{ func: { name: 'uid', uid: excludedUids } }],
    }]);

    return query;
  };

  return queries.map(processBlock);
};
